'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ptr = require('./ptr');

var _ptr2 = _interopRequireDefault(_ptr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ptr2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/ptr/index.js
// module id = 90
// module chunks = 0